import React, {createRef} from 'react';

import ApiResponse from '../message/ApiResponse';

import { getCurrentResource } from '../../util/tools';
import { 
	PROGRESS_INFO_API_URL, PROGRESS_BREAK_API_URL, PROGRESS_CLOSE_API_URL, 
	performApiRequest 
} from '../../util/restapi';
 

class ProgressInfo extends React.Component {
	
	processId = 0;
	messageReceived = 0;
	timerId = 0;
	refMessages = createRef();
	
	/*
		visible
		startTaskResponse
		title
		interval (ms)
		close
	*/
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.progressinfo.ProgressInfo;
		if ( props.startTaskResponse.success )
			this.processId = props.startTaskResponse.data;
		this.state = {
			progressState : {
				messages: [],
				isDeterminate: false,
				percent: 0,
				processed: 0,
				total: 1000,
				complete: false
			}
		}
	}
	componentDidMount() {
		this.updateProgressInfo();
		this.timerId = setInterval(this.updateProgressInfo, this.props.interval);
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		if( this.refMessages.current != null )
			this.refMessages.current.scrollTop = this.refMessages.current.scrollHeight;
	}
	componentWillUnmount() {
		if( this.timerId != 0 )
			clearInterval( this.timerId );
	}
	
	break = async () => {
		let request = {processId: this.processId, messageReceived: this.messageReceived};
		let response = await performApiRequest(PROGRESS_BREAK_API_URL, request);
		if( ! response.success ) {
			let progressState = this.state.progressState;
			progressState.messages.push( {level: 0, text: response.message} )
		}
	}
	
	updateProgressInfo = async () => {
		let progressState = this.state.progressState;
		let request = {processId: this.processId, messageReceived: this.messageReceived};
		let response = await performApiRequest(PROGRESS_INFO_API_URL, request);
		if( response.success ) {
			progressState.isDeterminate = response.data.isDeterminate;
			progressState.processed = response.data.processedCount;
			progressState.total = response.data.totalCount;
			progressState.percent = progressState.total > 0 ? 
				Math.round(progressState.processed * 100 / progressState.total) : 0; 
			progressState.complete = response.data.isComplete; 
			for( let msg of response.data.listMessage ) {
				progressState.messages.push( msg );
			}
			this.messageReceived += response.data.listMessage.length;
			if( response.data.isComplete ) {
				clearInterval( this.timerId );
				this.timerId = 0;
				request = {processId: this.processId};
				// We don't wait for response and ignore him
				performApiRequest(PROGRESS_CLOSE_API_URL, request);
			} 
		} else {
			progressState.messages.push( {level: 0, text: response.message} )
		}
		this.setState({
			progressState: progressState
		})
	}
	
	render() {
		let response = this.props.startTaskResponse;
		if( response == null )
			return null;
		if( this.props.visible ) {
			if( response.success ) {
				let progressState = this.state.progressState;
				let messagesHtml = progressState.messages.map((msg, index) => {
					let marginLeft = (msg.level*20) + 'px';
					return <div key={index} style={{marginLeft: marginLeft, marginBottom: '3px'}}>{msg.text}</div>
				})
				let buttonHtml = null;
				if( progressState.complete ) {
					buttonHtml = <ButtonClose holder={this} />
				} else {
					buttonHtml = 
						<button type='button' style={{padding: '3px 10px 3px 10px'}} onClick={this.break}>
							{this.resource.buttonBreak}
						</button>
				}
				return (
					<div style={{padding: '10px'}}>
						<div style={{textAlign:'center', marginBottom: '5px'}}>
							{this.props.title}
						</div>
						<div ref={this.refMessages} style={{marginTop: '10px', padding: '10px', height: '200px', overflowY: 'scroll', textAlign: 'left', border: '1px solid black'}}>
							{messagesHtml}
						</div>
						<ProgressBar progressState={progressState} />
						<div style={{marginTop: '10px', textAlign: 'right'}}>
							{buttonHtml}
						</div>
					</div>
				);
			} else {
				return (
					<div>
						<ApiResponse response={response} />
						<div style={{padding: '10px', textAlign: 'right'}}>
							<ButtonClose holder={this} />
						</div>
					</div>
				);
			}
		} else {
			return null;
		}
	}
}

function ProgressBar(props) {
	let progressState = props.progressState;
	if( progressState.isDeterminate ) {
		let percent = progressState.percent;
		let processed = progressState.processed;
		let total = progressState.total;
		return (
			<div style={{marginTop: '10px', border: '1px solid red', position: 'relative'}}>
				<div style={{width: percent + '%', height: '25px', backgroundColor: 'rgb(230,230,230)'}}>
				</div>
				<div style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '25px', paddingTop: '3px', textAlign: 'center'}}>
					{percent}% ({processed} / {total})
				</div>
			</div>
		)	
	}

	let	divStyle = {
		marginTop: '10px', paddingTop: '9px', height: '25px',
		border: '1px solid red',
		backgroundColor: 'rgb(230,230,230)',
		textAlign: 'center', fontSize: '8pt'
	}
	return (
		<div style={divStyle}>
			<span>●</span>
			<span style={{margin: '0 20px 0 20px'}}>●</span>
			<span>●</span>
		</div>
	)	
}

function ButtonClose(props) {
	return (
		<button type='button' onClick={props.holder.props.close} style={{padding: '3px 10px 3px 10px'}}>
			{props.holder.resource.buttonClose}
		</button>
	);
}

export default ProgressInfo;